var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("form-header", {
        attrs: {
          title: _vm.$t("ObjectsSelected"),
          "is-multi-select": _vm.isMultiSelect,
          "active-tab-layer": _vm.activeTabLayer
        },
        on: {
          close: function($event) {
            return _vm.$emit("closeForm")
          }
        }
      }),
      _vm._v(" "),
      _vm.numberOfTabs > 0
        ? _c(
            "v-tabs",
            {
              key: _vm.height + _vm.width,
              attrs: {
                value: _vm.activeTab,
                "background-color": "transparent",
                "show-arrows": "",
                centered: "",
                height: "40px"
              }
            },
            [
              _c("v-tabs-slider", {
                key: _vm.height + _vm.width,
                attrs: { color: "accent" }
              }),
              _vm._v(" "),
              _vm._l(_vm.tabs, function(tab, index) {
                return _c(
                  "v-tab",
                  {
                    key: tab.label,
                    staticStyle: {
                      "text-transform": "none",
                      "font-size": "12px"
                    },
                    attrs: { disabled: _vm.disableTabs },
                    on: {
                      change: function($event) {
                        return _vm.$emit("startTabChange", index)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$tc(_vm.getTranslationKey(tab.layer), 2)) +
                        "\n    "
                    )
                  ]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeTabLayer !== undefined
        ? _c("multi-selection-tab", {
            attrs: {
              "max-height": _vm.height,
              layer: _vm.activeTabLayer,
              "can-modify-objects": _vm.canModifyObjects,
              "can-generate-request": _vm.canGenerateRequest,
              "can-highlight-objects": _vm.canHighlightObjects
            },
            on: {
              loadingObjects: function($event) {
                _vm.disableTabs = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showWarning && _vm.canModifyObjects
        ? _c(
            "v-layout",
            {
              staticStyle: {
                "padding-bottom": "10px",
                "background-color": "#f0f0ef"
              },
              attrs: { "justify-center": "" }
            },
            [
              _c(
                "div",
                { staticClass: "message" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "pr-2",
                      attrs: { color: "#515358", size: "12" }
                    },
                    [_vm._v("warning")]
                  ),
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("WarningMultiSelectFieldsDepend")) +
                      "\n      "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("WarningMultiSelectEditIndividual")) +
                      "\n    "
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-684539cf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-684539cf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/MultipleObjectsSelectedWindow.vue
// module id = null
// module chunks = 